import { FC, ReactElement } from 'react'
import Link from 'next/link'
import styles from './index.module.scss'
import { EditAndDeleteButtons } from '../../atoms/EditAndDeleteButtons'

type Props = {
  comment: string
  href: string
  renderLogo: () => ReactElement
  renderName: () => ReactElement
  // 応援コメントで使用
  isTwoColumn?: boolean
  // 公開ページの応援コメント一覧ページで使用
  haveEditAndDelete?: boolean
  onClickEdit?: () => void
  onClickDelete?: () => void
  // 非公開ページの応援コメント一覧ページで使用
  haveToggleStatus?: boolean
  isSubmitting?: boolean
  onClickToggleStatus?: () => void
}

export const CommentCard: FC<Props> = ({
  comment,
  href,
  renderLogo,
  renderName,
  isTwoColumn = false,
  haveEditAndDelete = false,
  onClickEdit,
  onClickDelete,
  haveToggleStatus = false,
  isSubmitting = false,
  onClickToggleStatus,
  children,
}) => {
  if (isTwoColumn) {
    return (
      <div className={styles.twoColumnContainer}>
        <div className={styles.left}>
          <div className={styles.comment}>{comment}</div>
          <Link href={href}>
            <a className={styles.header}>
              <div className={styles.logo}>{renderLogo()}</div>
              <div className={styles.nameContent}>{renderName()}</div>
            </a>
          </Link>
        </div>
        <div className={styles.right}>
          {haveEditAndDelete && <EditAndDeleteButtons onClickEdit={onClickEdit} onClickDelete={onClickDelete} />}
          {haveToggleStatus && (
            <button className={styles.toggle} type='button' onClick={onClickToggleStatus} disabled={isSubmitting}>
              {children}
            </button>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.comment}>{comment}</div>
      <Link href={href}>
        <a className={styles.header}>
          <div className={styles.logo}>{renderLogo()}</div>
          <div className={styles.nameContent}>{renderName()}</div>
        </a>
      </Link>
    </div>
  )
}
